import React, { useState } from 'react';
import './popUp.css'; // Optional for styling
import Button from 'react-bootstrap/Button';

 const PopupWithText = ({ isOpen, onClose,onSubmitCancel,cancelPopupData }) => {
  const [text, setText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitted:', text);
    cancelPopupData.cancelReason=text
    cancelPopupData.cancelBy='vendor'
    onSubmitCancel(cancelPopupData)
    onClose(); // Close the popup after submission
  };

  if (!isOpen) return null; // Do not render if not open

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h4>Reason for Cancel</h4>
        <form onSubmit={handleSubmit}>
          <label>
            Write Details:
            {/* <input
              type="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              required
            /> */}

                      <textarea
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                          required
                          style={{ fontSize: '1.5em', padding: '10px', width: '100%', height: '150px' }} // Style adjustments
                      />
          </label>
          <div className="button-group">
            <Button className='primary-button submit' type="submit">Submit</Button>
            <Button className='secondary-button bg-black cancel' onClick={onClose}>{"Cancel"}</Button>

          </div>
        </form>
      </div>
    </div>
  );
};

export default PopupWithText


